import Lembrar from 'core/views/Lembrar.vue'
import Alterar from 'core/views/Alterar.vue'
import HealthCheck from '@bmp-vue/core/views/HealthCheck.vue'
import Ativar from 'core/views/Ativar.vue'

export default [
  {
    path: '/',
    view: 'Login',
    title: 'Login',
    dir: 'views/',
    home: true,
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/parceiro',
    view: 'LoginEmpresa',
    title: 'Login Empresa',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/auth/:ambiente?',
    dir: 'views/',
    view: 'LoginCustom',
    title: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/lembrar',
    component: Lembrar,
    default: true,
    title: 'Lembrar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    component: Alterar,
    default: true,
    title: 'Alterar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/ativar',
    component: Ativar,
    default: true,
    title: 'Ativar conta',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/healthcheck',
    component: HealthCheck,
    default: true,
    title: 'Health Check',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
]
